import { Image, Link } from "components/base";
import { Container, ContainerFluid, Flex } from "components/base/container";
import { ArrowIcon } from "components/icon/icon.arrow";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import { StakedNftColections } from "./app.comp";

const AppPage = () => {
  const navigate = useNavigate();
  return (
    <ContainerFluid>
      <Container col py={["72px", "72px", "78px", "100px"]}>
        <Flex
          gridGap={"8px"}
          flexWrap={"wrap"}
          mr={"auto"}
          pb={"8px"}
          color={"white"}
          fontWeight={"700"}
          fontSize={["42px", "42px", "45px", "48px"]}
          lineHeight={"100%"}
          borderBottom={"4px solid"}
          style={{
            borderImage: "linear-gradient(103.29deg, #E667B1 5.49%, #8767E6 100%) 30",
          }}
        >
          Staked NFT
          <Flex color={"#F2C65B"}>Collections</Flex>
        </Flex>
        <StakedNftColections />
        <Flex mt={"100px"}>
          <Link
            mr={"auto"}
            background={"linear-gradient(103.29deg, #E667B1 5.49%, #8767E6 100%)"}
            p={"16px 32px"}
            borderRadius={"100px"}
            fontWeight={"600"}
            fontSize={"28px"}
            lineHeight={"100%"}
            textTransform={"uppercase"}
            color={"white"}
            onClick={() => {
              navigate("/setup_staking");
            }}
          >
            Set up staking now
          </Link>
        </Flex>
      </Container>
    </ContainerFluid>
  );
};

export default AppPage;
